import {
    createAsyncErrorGuard,
    createErrorGuard,
    ErrorGuardConfig,
    ErrorGuardCallbackOptions,
} from '@superbet-group/web.lib.vue-utilities';

import { logger } from '@app/logger';

let errorGuardInstance: <T>(
    action: () => T,
    callbackOptions?: ErrorGuardCallbackOptions | undefined,
) => Promise<T | undefined>;

export function initErrorGuard(config: ErrorGuardConfig) {
    errorGuardInstance = createErrorGuard(logger, config);
}

export function errorGuard<T>(
    action: () => T,
    callbackOptions?: ErrorGuardCallbackOptions,
): Promise<T | undefined> {
    return errorGuardInstance(action, callbackOptions);
}
export const asyncErrorGuard = createAsyncErrorGuard(logger);
